import { DateTime } from 'luxon';
import { ChatSession } from './chat.model';

/** The session's modification time in milliseconds, or 0 when missing or invalid. */
function modifiedMillis(session: ChatSession): number {
  const date = DateTime.fromISO(session.modifiedAt ?? '');
  return date.isValid ? date.toMillis() : 0;
}

/** Compares two sessions by modification date, with the most recently modified first. */
export function sortSessionsByModified(previous: ChatSession, next: ChatSession): number {
  return modifiedMillis(next) - modifiedMillis(previous);
}
